import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { cities } from '../config/cities';
import { names } from '../config/names';
import { companies } from '../config/companies';
import { TbCalendarEvent, TbChecks, TbMapPin, TbUserPlus } from 'react-icons/tb';
import { getRandomFloat, getRandomInt } from '../utils/randomInt';
import { StaticImage } from 'gatsby-plugin-image';
import DynamicImage from './shared/DynamicImage';

export default function CTAFace({
  className = "",
  sizeClassName = "max-w-[50px] max-h-[50px] lg:max-w-[65px] lg:max-h-[65px]",
  ...rest
}) {

  const types = ["lead", "meeting", "sale"];

  const [ invisible, setInvisible ] = useState(true);

  const [ type, setType ] = useState(types[Math.floor(Math.random() * types.length)])
  const [ rand, setRand ] = useState(Math.random() * 100000);
  const [ gender, setGender ] = useState(Math.random() < 0.5 ? "male" : "female");
  const [ name, setName ] = useState(names?.filter(name => name.gender == gender)[Math.floor(Math.random() * names?.filter(name => name.gender == gender).length)].name)
  const [ profilePictureN, setProfilePictureN ] = useState(getRandomInt(1, 60))
  const [ company, setCompany ] = useState(companies[Math.floor(Math.random() * companies.length)])
  const [ meetingDate, setMeetingDate ] = useState(new Date(new Date().getTime() + 1000 * 3600 * 24 * getRandomInt(1, 10)));
  const [ city, setCity ] = useState(cities[Math.floor(Math.random() * cities.length)]);
  const [ amount, setAmount ] = useState(getRandomFloat(49.99, 999.99));
  const [ productService, setProductService ] = useState(Math.random() < 0.5 ? "product" : "service");

  const getColor = () => {
    switch (type) {
      case "lead":
        return "bg-black border-black";
      case "meeting":
        return "bg-primary-600 border-primary-600";
      case "sale":
        return "bg-green-600 border-green-600";
    }
  }

  const getIcon = () => {
    switch (type) {
      case "lead":
        return <TbUserPlus className='text-white shrink-0' />;
      case "meeting":
        return <TbCalendarEvent className='text-white shrink-0' />;
      case "sale":
        return <TbChecks className='text-white shrink-0' />;
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setInvisible(false)
    }, 100);
  }, []);

  return (
    <div className={`relative shrink-0 ${className}`} {...rest}>
      <img 
        src={`/images/faces/${gender}_${profilePictureN}.jpg`}
        alt={name}
        className={`${sizeClassName} !max-w-none shrink-0 bg-gray-600 rounded-full border-[3px] ${getColor()}`} 
      />
      <div className={`!absolute !w-[22px] !h-[22px] bottom-0 right-0 flex items-center justify-center rounded-full ${getColor()}`}>
        {getIcon()}
      </div>
    </div>
  )
}
